<div class="row page-title">
  <app-back-button [title]="localizationConstants.ADMIN_BACK_BUTTON_TITLE"></app-back-button>
  <span>{{ localizationConstants.APPROVED_SERVICE_PRICE_PAGE_TITLE | translate }}</span>
</div>
<div class="row">
  <div class="col">
    <div class="col-12 col-md-6 o-grid">
      <label
        class="c-form-label approved-max-price-label"
        for="role"
        >{{ localizationConstants.APPROVED_SERVICE_PRICE_FAM | translate }}</label
      >
      <div class="o-grid__item col-12 col-sm-6">
        <mat-select
          [(ngModel)]="fam"
          id="fam"
          name="fam"
          class="c-user-menu__select c-select c-select--lg"
          (ngModelChange)="onChange()"
          required>
          <mat-option
            *ngFor="let fam of fams"
            [value]="fam">
            {{ fam }}
          </mat-option>
        </mat-select>
      </div>
      <div class="o-grid__item col-12 col-sm-6">
        <button
          [disabled]="!fam"
          (click)="openModal()"
          type="button"
          class="button button-primary button-block">
          {{ localizationConstants.BUTTON_ADD | translate }}
        </button>
      </div>
    </div>
    <div class="col-12 o-grid"></div>

    <div class="col">
      <div class="o-grid u-pb--medium">
        <div class="o-grid__item col-12 col-md-3 col-sm-5">
          <form class="c-search-form--full">
            <div class="c-input-group">
              <input
                type="text"
                name="search"
                id="input-search"
                [(ngModel)]="dataSource.filter"
                class="c-input c-input--beta"
                placeholder="{{ localizationConstants.APPROVED_SERVICE_PRICE_SEARCH | translate }}"
                required />
              <input
                *ngIf="dataSource.filter"
                id="visible-events-clear"
                (click)="dataSource.filter = ''"
                class="c-button c-button--search c-close-search c-button--search--sm"
                value="Clear" />
              <input
                *ngIf="!dataSource.filter"
                id="visible-events-search"
                type="submit"
                class="c-button c-button--search c-button--search--sm"
                value="Search" />
            </div>
          </form>
        </div>
      </div>
      <div
        id="visible-events"
        class="col bg-white u-shadow u-scroll--horizontal">
        <div
          id="visible-events-table"
          class="tools-table col">
          <table
            mat-table
            #priceTable
            matSort
            [dataSource]="dataSource"
            class="c-table col-12 col-md-8 c-table--expandable">
            <ng-container matColumnDef="value">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="c-table__column-title"
                width="30%">
                {{ localizationConstants.APPROVED_SERVICE_PRICE_MAX_SERVICE_PRICE | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let item">
                {{ item.value | titlecase }}
              </td>
            </ng-container>

            <ng-container matColumnDef="customBoolean1">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="c-table__column-title"
                width="30%">
                {{ localizationConstants.APPROVED_SERVICE_PRICE_PO_MANDATORY | translate }}
              </th>
              <td
                mat-cell
                *matCellDef="let item">
                <div>
                  <input
                    type="checkbox"
                    [name]="item.value + 'Slider'"
                    [id]="item.value + 'Slider'"
                    class="c-checkbox-slider"
                    [(ngModel)]="item.customBoolean1"
                    (ngModelChange)="activate(item)" />
                  <label
                    [for]="item.value + 'Slider'"
                    class="c-switch-slider--left"></label>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th
                mat-header-cell
                *matHeaderCellDef></th>
              <td
                mat-cell
                *matCellDef="let item">
                <button
                  (click)="remove(item)"
                  type="button"
                  class="button button-primary button-block">
                  {{ localizationConstants.BUTTON_REMOVE | translate }}
                </button>
              </td>
            </ng-container>

            <tr
              matNoDataRow
              *matNoDataRow>
              <td colspan="4">
                <div class="center">
                  {{ localizationConstants.TABLE_NO_RESULTS | translate }}
                </div>
              </td>
            </tr>

            <tr
              mat-header-row
              *matHeaderRowDef="['value', 'customBoolean1', 'actions']"></tr>
            <tr
              mat-row
              *matRowDef="let item; columns: ['value', 'customBoolean1', 'actions']"
              class="c-table__row"></tr>
          </table>
          <div class="c-pagination--desktop">
            <div class="col-12">
              <mat-paginator
                [showFirstLastButtons]="true"
                [pageSize]="pageSize"
                [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
